import { useSelector } from "react-redux";
import { usePolls } from "../../../../../../hooks/use-polls";
import { selectBroadcastId } from "../../../../../../redux/broadcast/broadcast.selectors";
import EndedPoll from "../../components/ended-poll/ended-poll";

import * as SharedCSS from "../../polls-module.styles";

const EndedPolls = () => {
	const broadcastId = useSelector(selectBroadcastId);
	const polls = usePolls(broadcastId);

	const endedPolls = polls.filter((poll) => poll.ended);

	return (
		<SharedCSS.PollList>
			{endedPolls.map((poll) => (
				<EndedPoll key={poll.id} poll={poll} />
			))}
		</SharedCSS.PollList>
	);
};

export default EndedPolls;
